import { LazyLoaded } from 'hooks/common';
import React from 'react';

const BeamerButton = LazyLoaded(React.lazy(() => import('../BeamerButton')));
// const CreateAirmeetButton = LazyLoaded(
//     React.lazy(() => import('../CreateAirmeetButton'))
// );

export default function CommunityHeader({ isMobileOrTablet }) {
    const HEADER_LEFT = [
        // <span style={{ visibility: "hidden" }}>Profile</span>,
    ];

    const HEADER_CONTENT = [];

    const HEADER_RIGHT = [
        !isMobileOrTablet
            ? process.env.REACT_APP_BEAMER_WIDGET_ENABLED === 'true' && (
                  <>
                      <BeamerButton />
                      {/* <CreateAirmeetButton /> */}
                  </>
              )
            : null,
    ];

    return [HEADER_LEFT, HEADER_CONTENT, HEADER_RIGHT];
}
